import React from "react";
import { Redirect, Route } from "react-router-dom";
import Storage from '@/lib/storage'

const PrivateRoute = ({ component: Component, ...rest }) => {
  const isLogin = Boolean(Storage.get('GG_PRO_USER'))
  const loginPageFlag = rest.path === '/login'

  const renderComponent = (props) => {
    if (loginPageFlag) {
      return isLogin ? <Redirect
        to={{
          pathname: "/"
        }}
      /> : (
        <Component {...props} />
      )
    }

    return isLogin ? <Component {...props} /> : (
      <Redirect
        to={{
          pathname: "/login",
          state: { from: props.location }
        }}
      />
    )
  }

  return (
    <Route
      {...rest}
      render={
        renderComponent
      }
    />
  )
};

export default PrivateRoute;
